export const formattedActionTime = (timestamp) => {
  const actionDate = new Date(timestamp)
  return actionDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
}
